<div class="row mt-2">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4">
                <div>
                        <app-user-profile [context]="context" [userData]="userData"
                                (changeModalState)="changeRightPanel($event)"
                                (edituserPanel)="openEdituserPanel($event)">
                        </app-user-profile>
                </div>
        </div>

        <!-- Second Phase KYC Pannel & Communication -->
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-8">
                <app-kyc-pannel *ngIf="showKycPanel" [kycPannel]="kycData" [userData]="userData"></app-kyc-pannel>

                <app-communication *ngIf="showCommunicationPanel" [communicationData]='{ data: "ss"}'
                        (changeModalState)="changeRightPanel($event)"></app-communication>

                <app-client-addupdate *ngIf="showEditprofilePanel" [userData]="userData" [context]="currentContext"
                        [currentCustomer]='usereditData'
                        (edituserPanel)="openEdituserPanel($event)"></app-client-addupdate>

                <!-- Receipt Data Table -->
                <app-receipt-list *ngIf="showReceiptPanel" [paymentListData]="paymentData"
                        (editPaymentPanel)="changeRightPaymentPanel($event)"></app-receipt-list>
        </div>
</div>